import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../style/TokenError.css";

function TokenErrorPage() {
    const location = useLocation();
    const navigate = useNavigate();

    const params = new URLSearchParams(location.search);
    const code = params.get("code");
    const message = params.get("message");

    return (
        <div className="token-error-container">
            <div className="token-error-card">
                <h1>⚠️ Authentication Failed</h1>

                <p className="error-message">
                    {message || "Fayda authentication service is currently unavailable."}
                </p>

                {code && (
                    <p className="error-code">
                        Error Code: <strong>{code}</strong>
                    </p>
                )}

                <div className="button-group">
                    <button onClick={() => navigate("/")}>
                        Go Back
                    </button>

                    <button onClick={() => window.location.reload()}>
                        Retry
                    </button>
                </div>
            </div>
        </div>
    );
}

export default TokenErrorPage;
